import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '@blueprint/link';
import { Heading3 } from '@blueprint/heading';

const StyledNavLink = styled(Link)(
    (props) => css`
        display: block;
        font-size: 14px;
        line-height: 20px;
        padding: 10px ${props.theme.spacing['64px']};
        font-weight: 400;
        text-decoration: none;
        border-radius: ${props.theme.borderRadius['4px']};
        color: ${props.theme.colors['primary-dark']};

        ${props.theme.mediaQueries.large} {
            padding: 10px ${props.theme.spacing['16px']};
        }

        &:focus,
        &:hover {
            font-weight: 400;
            text-decoration: none;
            transform: translateY(0);
        }

        &:focus {
            box-shadow: inset ${props.theme.focusRing};
        }
    `
);

const StyledMenuList = styled('ul')(
    (props) => css`
        margin-bottom: ${props.theme.spacing['16px']};
        padding-bottom: ${props.theme.spacing['8px']};
        border-bottom: 1px solid
            ${props.theme.colors['graphic-background-accent']};
        list-style: none;
        padding-left: 0;

        ${props.theme.mediaQueries.large} {
            &:last-child {
                margin-bottom: 0;
                padding-bottom: 0;
                border-bottom: none;
            }
        }

        li {
            ${props.theme.mediaQueries.large} {
                padding: 0;
            }

            &:hover {
                background-color: ${props.theme.colors[
                    'graphic-background-accent-light'
                ]};
            }
        }
    `
);

const SecondaryNavWrapper = styled('div')(
    (props) => css`
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        max-height: 0;
        transition: background ease 0.35s, max-height 0.35s ease 0s;
        background-color: ${props.theme.colors['graphic-background']};

        ${props.theme.mediaQueries.large} {
            position: absolute;
            height: auto;
            max-height: initial;
            margin-top: -100em;
            transition: none;
            visibility: visible;
            width: 264px;
            box-shadow: 0px 0px 8px rgba(50, 39, 68, 0.04),
                0px 0px 1px rgba(50, 39, 68, 0.32),
                0px 8px 8px -8px rgba(50, 39, 68, 0.16);
            border-radius: 0 0 ${props.theme.spacing['8px']}
                ${props.theme.spacing['8px']};
            overflow: hidden;
            z-index: -1;

            &:hover {
                margin-top: 0;
            }
        }

        ${props.theme.mediaQueries
            .large} and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            max-height: 9999px;
        }

        ${Heading3} {
            font-size: 14px;
            line-height: 20px;
            padding: 10px ${props.theme.spacing['64px']};

            ${props.theme.mediaQueries.large} {
                padding: 10px ${props.theme.spacing['16px']};
            }
        }
    `
);

export { StyledNavLink, StyledMenuList, SecondaryNavWrapper };
